import GridSkeleton from '../../components/GridSkeleton';

const TOOLBAR_KEYS = [
  'grid-toolbar-1',
  'grid-toolbar-2',
  'grid-toolbar-3',
  'grid-toolbar-4',
  'grid-toolbar-5',
];

const GridBodySkeleton = () => (
  <>
    <div className="d-flex flex-wrap align-items-center gap-2 mb-3 pb-2 border-bottom">
      {TOOLBAR_KEYS.map((key) => (
        <span
          key={key}
          className="placeholder rounded"
          style={{ width: 72, height: 28 }}
        />
      ))}
      <span
        className="placeholder rounded ms-auto"
        style={{ width: 120, height: 28 }}
      />
    </div>
    <GridSkeleton rows={8} columns={5} variant="v3" showHeader />
  </>
);

interface ViewGridGridSkeletonProps {
  /** `full` = page section with card wrapper; `embedded` = inner body only (ViewGridContainer). */
  variant?: 'full' | 'embedded';
}

/** Layout-accurate grid body — toolbar strip + v3 card + themed header table. */
const ViewGridGridSkeleton = ({ variant = 'full' }: ViewGridGridSkeletonProps) => {
  if (variant === 'embedded') {
    return (
      <div className="placeholder-glow" aria-hidden="true">
        <GridSkeleton rows={8} columns={5} variant="v3" showHeader />
      </div>
    );
  }

  return (
    <div className="container-fluid" aria-hidden="true">
      <div className="row">
        <div className="col order-sm-2 order-md-2 overflow-hidden mt-1">
          <div className="ao_mainContainer">
            <div className="ao_reportContainer v3-report-content-card placeholder-glow">
              <GridBodySkeleton />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewGridGridSkeleton;
